define( [
	"./fnToString"
], function( fnToString ) {
	"use strict";

	return fnToString.call( Object );
} );



//////////////////
// WEBPACK FOOTER
// ./node_modules/jquery/src/var/ObjectFunctionString.js
// module id = 296
// module chunks = 0